<template>
    <div class="bg-image-wrapper" :class="{'overflow-hidden': !overflow}" :style="{
            backgroundColor: bgColor
        }">

        <img @load="imageLoadHandler()" :src="src" style="display:none;">

        <parallax v-if="parallax" :speedFactor="parallax.speedFactor" :direction="parallax.direction"
            :fixed="parallax.fixed" :sectionHeight="parallax.sectionHeight" :breakpoint="parallax.breakpoint"
            :sectionClass="parallax.sectionClass" :containerClass="parallax.containerClass"
            :parallaxClass="parallax.parallaxClass" :fixedClass="parallax.fixedClass">
            <div class="bg-image" :class="{
                    'image-loaded': loaded,
                    'blur-effect': blur,
                    'opacity-effect': effect==='opacity'
                }" :style="{
                    opacity: opacity,
                    backgroundImage: 'url(' + imageSrc + ')',
                    backgroundColor: bgColor
                }">
            </div>
        </parallax>

        <template v-else>
            <div v-if="placeholder" class="bg-image bg-image-low" :class="{
                    'image-loaded': loaded,
                    'blur-effect': blur,
                    'opacity-effect': effect==='opacity'
                }" :style="{
                    opacity: opacity,
                    backgroundImage: 'url(' + placeholder + ')'
                }">
            </div>
            <div class="bg-image bg-image-high" :class="{
                    'image-loaded': loaded,
                    'blur-effect': blur,
                    'opacity-effect': effect==='opacity'
                }" :style="{
                    opacity: opacity,
                    backgroundImage: 'url(' + src + ')'
                }">
            </div>
        </template>

        <slot></slot>
    </div>
</template>

<script>
    import Parallax from 'vue-parallaxy'

    export default {
        components: {
            Parallax
        },
        props: {
            src: {
                type: String,
                required: true,
                default: null
            },
            placeholder: {
                type: String,
                required: false
            },
            bgColor: {
                type: String,
                required: false,
                default: null
            },
            opacity: {
                type: Number,
                required: false,
                default: 1
            },
            effect: {
                type: String,
                required: false,
                default: null
            },
            parallax: {
                type: Object,
                required: false,
                default: null
            },
            overflow: {
                type: Boolean,
                required: false,
                default: false
            },
            debug: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                loaded: false,
                changing: false
            }
        },
        computed: {
            blur() {
                return (this.placeholder) ? true : false;
            },
            imageSrc: {
                get: function () {
                    if (!this.loaded && this.placeholder) {
                        return this.placeholder;
                    } else {
                        return this.src;
                    }
                },
                set: function (newValue) {}
            }
        },
        methods: {
            imageLoadHandler() {
                if (!this.debug) {
                    this.loaded = true;
                }
            },
        },
        beforeCreate() {
            // console.log('beforeCreate');
        },
        created() {
            // console.log('created');
        },
        beforeMount() {
            // console.log('beforeMount');
        },
        mounted() {
            // console.log('mounted');
        },
        beforeUpdate() {
            // console.log('beforeUpdate');
        },
        updated() {
            // console.log('updated');
        },
        beforeDestroy() {
            // console.log('beforeDestroy');
        },
        destroyed() {
            // console.log('destroyed');
        },
    }
</script>

<style lang="scss">
    .bg-image-wrapper {
        position: relative;

        &.overflow-hidden {
            overflow: hidden;
        }

        &.bg-contain {
            .bg-image {
                background-size: contain;
            }
        }

        &.bg-left {
            .bg-image {
                background-position: 0% 0%;
            }
        }

        &.bg-right {
            .bg-image {
                background-position: 100% 0%;
            }
        }

        &.bg-right-40 {
            .bg-image {
                background-position: 60% 0%;
            }
        }

        &.bg-top {
            .bg-image {
                background-position: 50% 0%;
            }
        }

        &.bg-bottom {
            .bg-image {
                background-position: 50% 100%;
            }
        }

        &.bg-fixed {
            position: fixed;
            left: 0;
            right: 0;
            z-index: -1;
        }

        .Masthead {
            position: absolute;
            width: 100%;
        }
    }

    .bg-image {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0%;
        left: 0%;
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
        backface-visibility: hidden;

        &.opacity-effect {
            opacity: 0;
            transition: opacity 250ms ease-out;

            &.image-loaded {
                opacity: 1;
            }
        }

        &.blur-effect {
            width: 100%;
            height: 100%;
            top: 0%;
            left: 0%;
            filter: blur(30px);

            &.image-loaded {
                filter: blur(0px);
                transition: filter 1000ms ease-out;
            }
        }

        &.bg-image-low {
            &.image-loaded {
                opacity: 0;
            }
        }

        &.bg-image-high {
            &.blur-effect {
                opacity: 0;

                &.image-loaded {
                    opacity: 1;
                    filter: blur(0);
                    transition: opacity 250ms ease-out, filter 1000ms ease-out;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/js/components/bg-image/bg-image.vue